import React from "react";
import { GlobalContext } from "../../../utils/globalprovider.js";
import { configurations_getDefaultParams } from "../../../utils/configurations.js";

import ToolsBar from "../../../components/bases/toolsbar/toolsbar.js";


import { apiReadOneConfiguration,apiCreateConfiguration, apiSearchConfiguration, apiUpdateConfiguration } from "../../../utils/apis.js";

import ComboClient from "./select/comboclient.js";
import ComboDiff from "./select/combodiff.js";
import ComboTypeConf from "./select/combotypeconf.js";
import ListConfig from "./listconfig.js";

import imgconfigadd from "./assets/configadd.png"
import imgconfigdup from "./assets/configdup.png"
import imgconfigexit from "./assets/configexit.png"
import imgconfigload from "./assets/configload.png"
import imgconfigpoub from "./assets/configpoub.png"
import imgconfigsave from "./assets/configsave.png"
import imgconfigselect from "./assets/configselect.png"


import "./confmanager.css"


class ConfManager extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super (props);

        /*
            toolsbar : {
                            height: 26,
                            items: [
                                {type:"space"},
                                {img: imgconfigadd ,type:"button", disable:false,fr:"Nouvelle configuration",en:"New configuration", nochangecolor:false, key:{key:"ADD", cat:"actions"}},
                                {img: imgconfigdup ,type:"button", disable:false,fr:"Dupliquer la configuration",en:"Duplicate this configuration", nochangecolor:false, key:{key:"DUP", cat:"actions"}},
                                {img: imgconfigload ,type:"button", disable:false,fr:"Charger la configuration",en:"Load configuration", nochangecolor:false, key:{key:"LOAD", cat:"actions"}},
                                {img: imgconfigsave ,type:"button", disable:false,fr:"Sauvegarder la configuration",en:"Save configuration", nochangecolor:false, key:{key:"SAVE", cat:"actions"}},
                                {img: imgconfigselect ,type:"button", disable:false,fr:"Sélectionner la configuration",en:"Select configuration", nochangecolor:false, key:{key:"SELECT", cat:"actions"}},
                                {type:"space"},
                                {img: imgconfigpoub ,type:"button", disable:false,fr:"Supprimer la configuration",en:"Delete configuration", nochangecolor:false, key:{key:"POUB", cat:"actions"}},
                                {type:"space"},
                                {img: imgconfigexit ,type:"button", disable:false,fr:"Fermer",en:"Close", nochangecolor:false, key:{key:"EXIT", cat:"actions"}},
                                {type:"space"},

                                ],
                        },
        */


        this.state = {
            currentConfiguration: this.props.codatas,
            stparams: this.props.stparams,
            title:"",
            subtitle:"",
            listconf: [],
            selected: 0,
        }





        if (this.props.codatas.coid > 0)
        {
            this.state.clientid = this.props.codatas.coclid;
            this.state.diffid = this.props.codatas.codiid;
            this.state.typeconf = this.props.codatas.cotype;
            this.state.coid = this.props.codatas.coid;
            this.state.coname = this.props.codatas.coname;
            this.state.configname = this.props.codatas.coname;
            this.state.selected = this.props.codatas.coid;
        }
        else
        {
            this.state.clientid = 0;
            this.state.diffid = 0;
            this.state.typeconf = 0;
            this.state.coid = 0;
            this.state.coname = "";
            this.state.configname = ""; // zone de saisie uniquement
        }

        
        switch (this.props.action)
        {
            case "select":
                break;
            case "load":
                if (this.props.codatas.coid > 0)
                    this.state.toolsbar = {
                            height: 26,
                            items: [
                                {type:"space"},
                                {img: imgconfigload ,type:"button", disable:false,fr:"Charger la configuration",en:"Load configuration", nochangecolor:false, key:{key:"LOAD", cat:"actions"}},
                                {type:"space"},
                                {img: imgconfigexit ,type:"button", disable:false,fr:"Fermer",en:"Close", nochangecolor:false, key:{key:"EXIT", cat:"actions"}},
                                {type:"space"},

                                ],
                        };
                    else
                        this.state.toolsbar = {
                                height: 26,
                                items: [
                                    {type:"space"},
                                    {img: imgconfigload ,type:"button", disable:false,fr:"Charger la configuration",en:"Load configuration", nochangecolor:false, key:{key:"LOAD", cat:"actions"}},
                                    {type:"space"},
                                    {img: imgconfigexit ,type:"button", disable:false,fr:"Fermer",en:"Close", nochangecolor:false, key:{key:"EXIT", cat:"actions"}},
                                    {type:"space"},

                                    ],
                            };

                break;

            case "save":

                if (this.props.codatas.coid > 0)
                    this.state.toolsbar = {
                            height: 26,
                            items: [
                                {type:"space"},
                                {img: imgconfigsave ,type:"button", disable:false,fr:"Sauvegarder la configuration",en:"Save configuration", nochangecolor:false, key:{key:"SAVE", cat:"actions"}},
                                {img: imgconfigadd ,type:"button", disable:false,fr:"Créer une configuration",en:"Create a new configuration", nochangecolor:false, key:{key:"ADD", cat:"actions"}},
                                {type:"space"},
                                {img: imgconfigpoub ,type:"button", disable:false,fr:"Supprimer la configuration",en:"Delete configuration", nochangecolor:false, key:{key:"POUB", cat:"actions"}},
                                {type:"space"},
                                {img: imgconfigexit ,type:"button", disable:false,fr:"Fermer",en:"Close", nochangecolor:false, key:{key:"EXIT", cat:"actions"}},
                                {type:"space"},

                                ],
                        };
                    else
                        this.state.toolsbar = {
                                height: 26,
                                items: [
                                    {type:"space"},
                                    {img: imgconfigadd ,type:"button", disable:false,fr:"Créer une configuration",en:"Create a new configuration", nochangecolor:false, key:{key:"ADD", cat:"actions"}},
                                    {type:"space"},
                                    {img: imgconfigexit ,type:"button", disable:false,fr:"Fermer",en:"Close", nochangecolor:false, key:{key:"EXIT", cat:"actions"}},
                                    {type:"space"},

                                    ],
                            };

                break;
            case "select":
                this.state.toolsbar = {};
                break;
        }


        this.toolsbarRef = React.createRef();
        this.inputRef = React.createRef();
        this.onClickToolsBar = this.onClickToolsBar.bind(this);

        this.onChangeClient = this.onChangeClient.bind(this);
        this.onChangeDiff = this.onChangeDiff.bind(this);
        this.onChangeTypeConf = this.onChangeTypeConf.bind(this);


        this.onCreateNewConfig = this.onCreateNewConfig.bind(this);
        this.onUpdateConfig = this.onUpdateConfig.bind(this);
        this.onLoadNewConfig = this.onLoadNewConfig.bind(this);
        this.onSearchConfigsDone = this.onSearchConfigsDone.bind(this);

    }

    componentDidMount()
    {
        if ((this.props.action === "load") || (this.props.action==="select"))
            this.searchConfigs(this.state.clientid, this.state.diffid, this.state.typeconf);

    }


    searchConfigs (client, diff, typeconf)
    {
        const datas  = {
            coid: 0,
            cotype: typeconf,
            coclid: client,
            codiid: diff,

        }
        apiSearchConfiguration (datas, this.onSearchConfigsDone)
    }

    onSearchConfigsDone(datas)
    {

        console.log("on search configs : ", datas)
        if (Array.isArray(datas))
            this.setState({listconf: datas})
    }

    onChangeClient(client)
    {
        this.setState({clientid: client});
        if ((this.props.action === "load") || (this.props.action==="select"))
            this.searchConfigs(client, this.state.diffid, this.state.typeconf);
    }

    onChangeDiff(diff)
    {
        this.setState({diffid: diff});
        if ((this.props.action === "load") || (this.props.action==="select"))
            this.searchConfigs(this.state.clientid, diff, this.state.typeconf);
    }

    onChangeTypeConf(typeconf)
    {
        this.setState({typeconf: typeconf});
        if ((this.props.action === "load") || (this.props.action==="select"))
            this.searchConfigs(this.state.clientid, this.state.diffid, typeconf);

    }

    onClickToolsBar(datas)
    {
        switch (datas.key)
        {
            case "EXIT":
                if (this.props.onaction) this.props.onaction ({source:"ConfManager", action: "EXIT"});
                break;
        }


        switch (this.props.action)
        {
            case "save":
                switch (datas.key)
                {
                    case "ADD":
                        if (this.state.configname.trim() === "")
                        {
                            this.inputRef.current.focus();
                            return;
                        }
                        // ok on peut créer cette configuration
                        const datas  = {
                            coname: this.state.configname.trim(),
                            coclid: this.state.clientid,
                            codiid:  this.state.diffid,
                            cotype: this.state.typeconf,
                            codatas: JSON.stringify(this.state.stparams),
                        }

                        console.log("creation de la configuration ", datas)
                        apiCreateConfiguration(datas, this.onCreateNewConfig);

                        break;
                    case "SAVE":
                        if (this.state.configname.trim() === "")
                        {
                            this.inputRef.current.focus();
                            break;
                        }
                        // ok on peut updater cette configuration
                        const datas2  = {
                            coid: this.state.coid,
                            coname: this.state.configname.trim(),
                            coclid: this.state.clientid,
                            codiid:  this.state.diffid,
                            cotype: this.state.typeconf,
                            codatas: JSON.stringify(this.state.stparams),
                        }

                        console.log("update de la configuration ", datas2)
                        apiUpdateConfiguration(datas2, this.onUpdateConfig);
                        break;
                    case "POUB":
                        if (this.props.codatas.coid > 0)
                            if (this.props.onaction) this.props.onaction ({source:"ConfManager", action: "DELETE", coid : this.props.codatas.coid, coname: this.props.codatas.coname});
                        break;
                }
                break;
            case "load":
                if (this.state.selected)
                    if (this.props.onaction) this.props.onaction ({source:"ConfManager", action: "NEWCONFIG", coid: this.state.selected});

                break;
            case "select":
                break;
        }

    }

    // fin d'update d'une configuration
    onUpdateConfig(datas)
    {
        console.log ("update configuration", datas);
        if (this.props.onaction) this.props.onaction ({source:"ConfManager", action: "NEWCONFIG", coid: datas.id});
    }

    // fin de creation d'une nouvelle configuration
    onCreateNewConfig(datas)
    {
        console.log ("retour creation d'une nouvelle configuration", datas)
        if (datas.ret)
        {
            const coid = datas.id;
            apiReadOneConfiguration(coid, this.onLoadNewConfig);
        }
    }



    // ici on a chargé une nouvelle configuration
    onLoadNewConfig(datas)
    {
        console.log ("confmanager : lecture d'une nouvelle configuration", datas)
        if (this.props.onaction) this.props.onaction ({source:"ConfManager", action: "NEWCONFIG", coid: datas[0].coid});
    }


    render()
    {

        var coname = this.state.coname;
        if (this.state.coid <1)
            coname = this.context.language=="fr"?"Configuration par défaut":"Default configuration";


        var title ="";
        var subtitle="";
        switch (this.props.action)
        {
            case "select":
                title = this.context.language=="fr"?"Sélectionner une configuration":"Select a configuration";
                subtitle = this.context.language=="fr"?"Configuration sélectionnée":"Selected configuration";
                break;
            case "save":
                title = this.context.language=="fr"?"Sauvegarder une configuration":"Save a configuration";
                subtitle = this.context.language=="fr"?"Configuration en cours":"Current configuration";
                break;
            case "load":
                title = this.context.language=="fr"?"Charger une configuration":"Load a configuration";
                subtitle = this.context.language=="fr"?"Configuration en cours":"Current configuration";
                break;
        }




        switch (this.props.action)
        {
            case "save":

                // *******************************************************************
                return (
                    <div className="configManager">
                        <div className="configManagerTop">

                            <div className="configManagerTitle">{title}</div>

                            <div className="configManagerCurrentDiv">
                                <div className="configManagerCurrentDivTop">
                                    {subtitle}
                                </div>
                                <div className="configManagerCurrentDivBottom">
                                    {this.state.coid<1?coname:this.state.coid+" "+coname}
                                </div>
                            </div>


                            <div className="configManagerSubtitle">Client</div>
                            <ComboClient 
                            onChange = {this.onChangeClient}
                            clientid = {this.state.clientid} />
                            <div className="configManagerSubtitle">{this.context.language=="fr"?"Diffuseur":"Diffusor"}</div>
                            <ComboDiff
                            onChange = {this.onChangeDiff}
                            diffid = {this.state.diffid}
                            />
                            <div className="configManagerSubtitle">Type</div>
                            <ComboTypeConf
                            onChange = {this.onChangeTypeConf}
                            typeconf = {this.state.typeconf}
                            />

                            <div className="configManagerSubtitle">
                                {this.context.language=="fr"?"Nom de la configuration":"Configuration name"}
                            </div>
                            <input 
                                type="text"
                                ref = {this.inputRef}

                                onChange={e => this.setState({configname:e.target.value})}
                                onKeyDown={e=>
                                {
                                    e.stopPropagation();
                                }
                                }
                                value={this.state.configname}
                                style = {
                                    
                                    {width: "90%", 
                                    marginTop: "3px",
                                    backgroundColor: "black",
                                    borderRadius: 3,
                                    paddingLeft: 3,
                                    color: "white",
                                    fontSize: "18px",
                                    borderStyle: "solid",
                                    caretColor: "white",
                                    textAlign: "left"}}
                                required />

                        </div>
                        <div className="configManagerBottom">
                            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar} />
                        </div>
                    </div>
                )
                break;
            
            case "load":
                return (
                    <div className="configManager">
                        <div className="configManagerTop">

                            <div className="configManagerTitle">{title}</div>

                            <div className="configManagerCurrentDiv">
                                <div className="configManagerCurrentDivTop">
                                    {subtitle}
                                </div>
                                <div className="configManagerCurrentDivBottom">
                                    {this.state.coid<1?coname:this.state.coid+" "+coname}
                                </div>
                            </div>



                            <div className="configManagerSectionTitle">
                                {this.context.language === "fr"
                                    ? "Critères de recherche"
                                    : "Search parameters"}
                            </div>

                            <div className="configManagerSubtitle">Client</div>
                            <ComboClient 
                            onChange = {this.onChangeClient}
                            clientid = {this.state.clientid} />
                            <div className="configManagerSubtitle">{this.context.language=="fr"?"Diffuseur":"Diffusor"}</div>
                            <ComboDiff
                            onChange = {this.onChangeDiff}
                            diffid = {this.state.diffid}
                            />
                            <div className="configManagerSubtitle">Type</div>
                            <ComboTypeConf
                            onChange = {this.onChangeTypeConf}
                            typeconf = {this.state.typeconf}
                            />
                            <br/>
                                <div className="configManagerSectionTitle">
                                    {this.context.language === "fr"
                                        ? "Configurations disponibles"
                                        : "Available configurations"}
                                </div>                               

                            <ListConfig 
                                list = {this.state.listconf}
                                selected = {this.state.selected}
                                onselect = { value => this.setState({selected: value})}
                            />
                        </div>
                        <div className="configManagerBottom">
                            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar} />
                        </div>
                    
                    </div>
                );


                case "select":
                    return (
                        <div className="configManager">
                            <div className="configManagerFull">

                                <div className="configManagerCurrentDiv">
                                    <div className="configManagerCurrentDivTop">
                                        {subtitle}
                                    </div>
                                    <div className="configManagerCurrentDivBottom">
                                        {this.state.coid<1?coname:this.state.coid+" "+coname}
                                    </div>
                                </div>

                                <div className="configManagerSectionTitle">
                                    {this.context.language === "fr"
                                        ? "Critères de recherche"
                                        : "Search parameters"}
                                </div>                               
                                 <div className="configManagerSubtitle">Client</div>
                                <ComboClient 
                                onChange = {this.onChangeClient}
                                clientid = {this.state.clientid} />
                                <div className="configManagerSubtitle">{this.context.language=="fr"?"Diffuseur":"Diffusor"}</div>
                                <ComboDiff
                                onChange = {this.onChangeDiff}
                                diffid = {this.state.diffid}
                                />
                                <div className="configManagerSubtitle">Type</div>
                                <ComboTypeConf
                                onChange = {this.onChangeTypeConf}
                                typeconf = {this.state.typeconf}
                                />
                                <br/>
                                <div className="configManagerSectionTitle">
                                    {this.context.language === "fr"
                                        ? "Configurations disponibles"
                                        : "Available configurations"}
                                </div>                               

                                <ListConfig 
                                    list = {this.state.listconf}
                                    selected = {this.state.selected}
                                    height = {160}
                                    onselect = { (value,  datas) => 
                                        {
                                            this.setState({selected: value});
                                            if (this.props.onselect) this.props.onselect ({ret:true, datas:datas})

                                        }
                                    }
                                />
                            </div>
                       
                        </div>
                    );



            default:
                // *******************************************************************
                return (<></>);
                break;
        }
    }

}


ConfManager.defaultProps = 
{ 
    codatas : {coid: -1},
    stparams: configurations_getDefaultParams(25,1),
    action: "none",
    onselect: null,
}

export default ConfManager;
